import React from 'react';
import {useTranslation} from 'react-i18next';
import {AddBusinessUnitForm} from '../../client/AddBusinessUnitForm';
import {StepLayout} from '../StepLayout';

/**
 * Reuses the existing AddBusinessUnitForm to create a control line,
 * pre-filled with the client created in step 1. The form's modal-like
 * footer renders a native Siguiente button.
 */
export function Step3ControlLines({clientId, clientName, initialValues, onComplete, onBack, stepNumber = 3}) {
    const {t} = useTranslation();

    return (
        <StepLayout
            stepNumber={stepNumber}
            title={t('onboarding_wizard.step2_title')}
            description={t('onboarding_wizard.step2_description')}
        >
            <div className="onboarding-embedded-form">
                <AddBusinessUnitForm
                    clientId={clientId}
                    clientName={clientName}
                    hideClientInput={true}
                    useConfigurationTypeCards={true}
                    draftMode={true}
                    initialValues={initialValues}
                    simplifiedOnboardingMode={true}
                    afterDraftSubmit={onComplete}
                    footerStartContent={(
                        <button type="button" className="onboarding-btn -ghost" onClick={onBack}>
                            {t('onboarding_wizard.back_to_previous_step')}
                        </button>
                    )}
                />
            </div>
        </StepLayout>
    );
}

export default Step3ControlLines;
